import {Component, Input, OnInit} from "@angular/core";
import {AreasDestinoService} from "../../services/areas-destino.service";
import {NotificationService} from "../../services/notification.service";

@Component({
  selector: 'app-tab-areas-destinos',
  templateUrl: './tab-areas-destinos.component.html',
  styleUrls: ['./tab-areas-destinos.component.scss']
})
export class TabAreasDestinosComponent implements OnInit {
  @Input() empresa: any;
  @Input() possuiModuloFiscal: boolean;
  @Input() possuiModuloKDS: boolean;

  areas: any[] = [];
  carregando = false;
  areaEmEdicao: any = null;
  exibirFormulario = false;

  constructor(private service: AreasDestinoService,
              private notification: NotificationService) { }

  ngOnInit(): void {
    this.carregar();
  }

  carregar() {
    this.carregando = true;
    this.service.liste().then((res: any) => {
      this.areas = res;
      this.carregando = false;
    }).catch(err => {
      this.carregando = false;
      console.error(err);
    });
  }

  novo() {
    this.areaEmEdicao = null;
    this.exibirFormulario = true;
  }

  editar(dataItem: any) {
    // Clona o objeto para não alterar na grid antes de salvar
    this.areaEmEdicao = JSON.parse(JSON.stringify(dataItem));
    this.exibirFormulario = true;
  }

  remover(dataItem: any) {
    if (confirm(`Tem certeza que deseja remover esta área "${dataItem.nome}" ?`)) {
      this.service.removaArea(dataItem).then(() => {
        this.notification.showSuccess('Área removida com sucesso.');
        this.carregar();
      }).catch(err => {
        this.notification.showError('Erro ao remover: ' + (err?.message || err));
      });
    }
  }

  onSalvo(area: any) {
    this.exibirFormulario = false;
    this.carregar();
  }

  onCancelado() {
    this.exibirFormulario = false;
  }
}
